module.exports = __webpack_public_path__ + "static_pc/img/ba06.dc509f45.png";